// Change this
const module = 'closures'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/closures/Index'
import Edit from "@/views/closures/Edit.vue";
import Create from "@/views/closures/Create.vue";

let prefix = '/'

export default [
    {
        path: prefix+`${module}/:centerId`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },

    {
        path: prefix+`${module}/:centerId/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/:centerId/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]

